import React from 'react';
import { twMerge } from 'tailwind-merge';
interface StatCardProps {
  title: string;
  value: string | number;
  icon: React.ReactNode;
  trend?: {
    value: string;
    isPositive: boolean;
  };
  className?: string;
}
export function StatCard({
  title,
  value,
  icon,
  trend,
  className
}: StatCardProps) {
  return <div className={twMerge('bg-white rounded-xl border border-slate-200 p-6 shadow-sm', className)} data-id="element-161">
      <div className="flex items-center justify-between mb-4" data-id="element-162">
        <h3 className="text-sm font-medium text-slate-500" data-id="element-163">{title}</h3>
        <div className="p-2 bg-slate-50 rounded-lg text-slate-600" data-id="element-164">{icon}</div>
      </div>
      <div className="flex items-baseline gap-2" data-id="element-165">
        <span className="text-3xl font-bold text-slate-900" data-id="element-166">{value}</span>
        {trend && <span className={twMerge('text-sm font-medium', trend.isPositive ? 'text-emerald-600' : 'text-red-600')} data-id="element-167">
            {trend.isPositive ? '+' : '-'}
            {trend.value}
          </span>}
      </div>
    </div>;
}